import { ReactElement, ReactNode, useMemo } from 'react'
import { find } from 'lodash-es'
import { TabContext, TabList } from '@mui/lab'
import { Tab } from '@mui/material'
import { StyledTabPanel } from '@ui/navigation'
import { Box } from '@ui/structure'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'
import VerticalTransmitterList from '../../../../VerticalTransmitterList'
import { purlinTabs } from '../tabs'

interface Props {
  selectedElement: string
  children?: ReactNode
  tab?: ReactNode
  initialTabValue: string
}

const PurlinFormBase = ({
  children,
  tab,
  initialTabValue,
  selectedElement,
}: Props): ReactElement => {
  const {
    modes: { isDrawMode },
    params: { verticalTransmitter, activeTab },
    actions: { setVerticalTransmitter, setActiveTab },
  } = useStructuralPlanningSelection()

  const selectedTab = useMemo(() => {
    if (activeTab && find(Object.entries(purlinTabs), ([, e]) => e.tab === activeTab))
      return activeTab

    return initialTabValue
  }, [activeTab, initialTabValue])

  return (
    <TabContext value={selectedTab}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            fontSize: 12,
            paddingX: ({ spacing }) => spacing(1.5),
          },
        }}
      >
        <TabList onChange={(_, value) => setActiveTab(value)} scrollButtons="auto">
          {tab}
          <Tab
            value={purlinTabs.verticalTransmission.tab}
            label={purlinTabs.verticalTransmission.label}
          />
        </TabList>
      </Box>
      {children}
      <StyledTabPanel value={purlinTabs.verticalTransmission.tab}>
        <VerticalTransmitterList
          selectedElement={selectedElement}
          verticalTransmitter={verticalTransmitter}
          setVerticalTransmitter={(guid, elementGuid) =>
            setVerticalTransmitter(guid, elementGuid, isDrawMode)
          }
        />
      </StyledTabPanel>
    </TabContext>
  )
}

export default PurlinFormBase
